import React, { Component } from "react";
import isEmpty from "assets/scripts/utils/isEmpty";
import { ERRORS, REQUIRED } from "assets/scripts/constants/FormMessages";
import { defineMessages, FormattedMessage } from "react-intl";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import Form, { RequiredMessage } from "assets/scripts/components/common/form/Form/Form";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import PhoneFormGroup from "assets/scripts/components/common/form/PhoneFormGroup/PhoneFormGroup";
import PhoneTypeFormGroup from "assets/scripts/components/common/form/PhoneTypeFormGroup/PhoneTypeFormGroup";
import { default as DecedentRelationshipFormGroup } from "assets/scripts/components/common/form/DecedentRelationshipFormGroup/DecedentRelationshipFormGroup";
import TextAreaFormGroup from "assets/scripts/components/common/form/TextAreaFormGroup/TextAreaFormGroup";
import validZip from "assets/scripts/utils/validZip";
import validPhone from "assets/scripts/utils/validPhone";
import getStateError from "assets/scripts/utils/getStateError";
import StateFormGroup from "assets/scripts/components/common/form/StateFormGroup/StateFormGroup";
import getMaxLengthError from "assets/scripts/utils/getMaxLengthError";
import ProbateCaseFormGroups, { getErrors as getProbateCaseErrors, EMPTY_PROBATE_CASE } from "../../ProbateCaseFormGroups/ProbateCaseFormGroups";
import styles from "./ReferForm.module.less";
const messages = defineMessages({
    submit: {
        id: "forms.refer.submit",
        defaultMessage: "Send"
    },
    firstNameLabel: {
        id: "forms.refer.firstName.label",
        defaultMessage: "First Name"
    },
    lastNameLabel: {
        id: "forms.refer.lastName.label",
        defaultMessage: "Last Name"
    },
    addressLabel: {
        id: "forms.refer.address.label",
        defaultMessage: "Address"
    },
    address2Label: {
        id: "forms.refer.address2.label",
        defaultMessage: "Address 2"
    },
    cityLabel: {
        id: "forms.refer.city.label",
        defaultMessage: "City"
    },
    cityHelp: {
        id: "forms.refer.city.help",
        defaultMessage: "Example: Springfield"
    },
    stateLabel: {
        id: "forms.refer.state.label",
        defaultMessage: "State"
    },
    stateHelp: {
        id: "forms.refer.state.help",
        defaultMessage: "Example: AK"
    },
    zipLabel: {
        id: "forms.refer.zip.label",
        defaultMessage: "Zip"
    },
    zipHelp: {
        id: "forms.refer.zip.help",
        defaultMessage: "Example: 12345"
    },
    phoneLabel: {
        id: "forms.refer.phone.label",
        defaultMessage: "Phone"
    },
    phoneHelp: {
        id: "forms.refer.phone.help",
        defaultMessage: "Example: 123-456-7890"
    },
    phoneTypeLabel: {
        id: "forms.refer.phoneType.label",
        defaultMessage: "Phone type"
    },
    phoneTypeNullOption: {
        id: "forms.refer.phoneType.nullOption",
        defaultMessage: "Select Phone Type"
    },
    relationshipLabel: {
        id: "forms.refer.relationship.label",
        defaultMessage: "Relationship to decedent"
    },
    relationshipNullOption: {
        id: "forms.refer.relationship.nullOption",
        defaultMessage: "Select Relationship"
    },
    commentsLabel: {
        id: "forms.refer.comments.label",
        defaultMessage: "Comments"
    }
});
function getErrors(value) {
    return {
        firstName: isEmpty(value.firstName) ? REQUIRED : getMaxLengthError(value.firstName, 50),
        lastName: isEmpty(value.lastName) ? REQUIRED : getMaxLengthError(value.lastName, 50),
        address: isEmpty(value.address) ? REQUIRED : getMaxLengthError(value.address, 256),
        city: isEmpty(value.city) ? REQUIRED : getMaxLengthError(value.city, 50),
        state: getStateError(value.state, true),
        zip: isEmpty(value.zip) || !validZip(value.zip) ? ERRORS.ZIP : null,
        phone: isEmpty(value.phone) || !validPhone(value.phone) ? ERRORS.PHONE : null,
        phoneType: value.phoneType === "Unspecified" ? ERRORS.SELECT : null,
        relationship: value.relationship === "" ? ERRORS.SELECT : null,
        probateCase: process.env.FEATURE_PROBATE_CASE_SUBMISSION
            ? getProbateCaseErrors(value.probateCase || EMPTY_PROBATE_CASE)
            : null
    };
}
export default class ReferForm extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleFirstNameChange = (firstName) => this.setState({ firstName });
        this._handleLastNameChange = (lastName) => this.setState({ lastName });
        this._handleAddressChange = (address) => this.setState({ address });
        this._handleAddress2Change = (address2) => this.setState({ address2 });
        this._handleCityChange = (city) => this.setState({ city });
        this._handleStateChange = (state) => this.setState({ state });
        this._handleZipChange = (zip) => this.setState({ zip });
        this._handlePhoneChange = (phone) => this.setState({ phone });
        this._handlePhoneTypeChange = (phoneType) => this.setState({ phoneType });
        this._handleRelationshipChange = (relationship) => this.setState({ relationship });
        this._handleCommentsChange = (comments) => this.setState({ comments });
        this._handleProbateCaseChange = (probateCase) => {
            const empty = isEmpty(probateCase.caseNumber)
                && isEmpty(probateCase.state)
                && isEmpty(probateCase.county)
                && isEmpty(probateCase.petitionDate)
                && isEmpty(probateCase.caseType)
                && isEmpty(probateCase.dod)
                && isEmpty(probateCase.dob);
            this.setState({ probateCase: empty ? null : probateCase });
        };
        this.state = {
            firstName: "",
            lastName: "",
            address: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            phone: "",
            phoneType: "Unspecified",
            relationship: "",
            comments: "",
            probateCase: null
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state: value } = this;
        const { probateCase: probateCaseErrors, ...errors } = getErrors(value);
        const isValid = [
            ...Object.values(errors),
            ...Object.values(probateCaseErrors || {})
        ].every(it => it == null);
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        return (<Form isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} error={globalError} className={process.env.FEATURE_PROBATE_CASE_SUBMISSION ? styles.form : ""} hideRequiredMessage={!!process.env.FEATURE_PROBATE_CASE_SUBMISSION}>
				<fieldset>
					<fieldset className="fieldset">
						<legend>
							<div className="vr vr_x4">
								<h1 className="hdg js-pageHeader">
									<FormattedMessage id="referAuthorizedUser.header" defaultMessage="Authorized Person Information"/>
								</h1>
							</div>

							<div className="vr vr_x5">
								<div className="text">
									<p>
										<FormattedMessage id="referAuthorizedUser.intro" defaultMessage={"Please provide information for the person who is "
            + "authorized to act on behalf of the Estate."}/>
									</p>
								</div>
							</div>
						</legend>

						{process.env.FEATURE_PROBATE_CASE_SUBMISSION && <RequiredMessage />}

						<TextFormGroup name="firstName" className={styles.formGroupLeft} label={messages.firstNameLabel} value={value.firstName} onChange={this._handleFirstNameChange} error={errors.firstName} backendError={backendErrors.firstName} required inputProps={{
            autoComplete: "given-name"
        }}/>

						<TextFormGroup name="lastName" className={styles.formGroupRight} label={messages.lastNameLabel} value={value.lastName} onChange={this._handleLastNameChange} error={errors.lastName} backendError={backendErrors.lastName} required inputProps={{
            autoComplete: "family-name"
        }}/>

						<TextFormGroup name="address" label={messages.addressLabel} value={value.address} onChange={this._handleAddressChange} error={errors.address} backendError={backendErrors.address} required inputProps={{
            autoComplete: "address-line1"
        }}/>

						<TextFormGroup name="address2" label={messages.address2Label} value={value.address2} onChange={this._handleAddress2Change} inputProps={{
            autoComplete: "address-line2"
        }}/>

						<TextFormGroup name="city" className="form-group-city" label={messages.cityLabel} value={value.city} onChange={this._handleCityChange} error={errors.city} backendError={backendErrors.city} required inputProps={{
            autoComplete: "address-level2"
        }}/>

						<StateFormGroup name="state" className="form-group-state" label={messages.stateLabel} value={value.state} onChange={this._handleStateChange} error={errors.state} backendError={backendErrors.stateProvince} required inputProps={{
            autoComplete: "address-level1"
        }}/>

						<TextFormGroup name="zip" className="form-group-zip" label={messages.zipLabel} value={value.zip} onChange={this._handleZipChange} error={errors.zip} backendError={backendErrors.postalCode} required inputProps={{
            autoComplete: "postal-code"
        }}/>

						<PhoneFormGroup name="phone" className={styles.formGroupLeft} label={messages.phoneLabel} value={value.phone} onChange={this._handlePhoneChange} error={errors.phone} backendError={backendErrors.phone} required inputProps={{
            autoComplete: "tel"
        }}/>

						<PhoneTypeFormGroup name="phoneType" className={styles.formGroupRight} label={messages.phoneTypeLabel} value={value.phoneType} onChange={this._handlePhoneTypeChange} error={errors.phoneType} backendError={backendErrors.phoneType} required nullOption={messages.phoneTypeNullOption}/>

						<DecedentRelationshipFormGroup name="relationship" label={messages.relationshipLabel} value={value.relationship} onChange={this._handleRelationshipChange} error={errors.relationship} backendError={backendErrors.decedentRelationship} required nullOption={messages.relationshipNullOption}/>

						<TextAreaFormGroup name="comments" label={messages.commentsLabel} value={value.comments} onChange={this._handleCommentsChange} backendError={backendErrors.comments}/>
					</fieldset>

					{process.env.FEATURE_PROBATE_CASE_SUBMISSION && (<fieldset>
							<legend>
								<div className="vr vr_x4">
									<h2 className="hdg">
										<FormattedMessage id="forms.refer.probateCase.legend.header" defaultMessage="Probate Case Information"/>
									</h2>
								</div>

								<div className="vr vr_x5">
									<div className="text">
										<p>
											<FormattedMessage id="forms.refer.probateCase.legend.info" defaultMessage={"Please provide information regarding the probated Estate."}/>
										</p>
									</div>
								</div>
							</legend>

							<RequiredMessage />

							<ProbateCaseFormGroups probateCase={value.probateCase || EMPTY_PROBATE_CASE} errors={probateCaseErrors} onChange={this._handleProbateCaseChange} namePrefix="probateCase"/>
						</fieldset>)}
				</fieldset>
			</Form>);
    }
    _handleSubmit() {
        const { referenceNumber, pin } = this.props;
        const { state, zip, relationship, ...other } = this.state;
        this.props.refer({
            ...other,
            referenceNumber,
            pin,
            stateProvince: state,
            postalCode: zip,
            decedentRelationship: relationship,
            languagePreference: null
        });
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/ReferForm/ReferForm.tsx